import { createContext, type PropsWithChildren, useContext } from 'react'
import type { VulcanAppContextValue } from './types'

const VulcanAppContext = createContext<VulcanAppContextValue | undefined>(undefined)

export function VulcanAppProvider({ children, value }: PropsWithChildren<{ value: VulcanAppContextValue }>) {
  return <VulcanAppContext.Provider value={value}>{children}</VulcanAppContext.Provider>
}

export function useVulcanApp(): VulcanAppContextValue {
  const context = useContext(VulcanAppContext)
  if (!context) throw new Error('useVulcanApp must be used within a VulcanAppProvider.')
  return context
}
